var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('show-chip-field',{attrs:{"chips":_vm.fileUsers,"label":_vm.$t('media.file.users'),"icon":"person"}})}
var staticRenderFns = []

export { render, staticRenderFns }